import {defineSlotRecipe} from '@chakra-ui/react3'

export const checkoutHeaderRecipe = defineSlotRecipe({
    className: 'checkout-header',

    slots: [
        'root',
        'cardContainer',
        'card',
        'bar',
        'barInner',
        'logoLink',
        'logoIcon',
        'rightSection',
        'accountLink',
        'secureLabel',
        'lockIcon'
    ],

    base: {
        root: {
            position: 'sticky',
            top: '0',
            zIndex: 'sticky',
            width: 'full',

            '--app-header-offset-inline': {
                base: '0px',
                s: 'spacing.spacing-20'
            },

            '--app-header-offset-block': {
                base: '0px',
                s: 'spacing.spacing-20'
            },

            '--container-inline-padding': {
                base: 'spacing.container-padding-mobile',
                s: 'spacing.spacing-92'
            }
        },

        cardContainer: {
            display: 'flex',
            justifyContent: 'center',
            paddingBlock: 'var(--app-header-offset-block)',
            paddingInline: 'var(--app-header-offset-inline)'
            // Deliberately bg-less, like the Xleap header's: a background here
            // would sit inside the sticky root and travel down the page with
            // the bar. The band is the page canvas instead (STOK-17630).
        },

        card: {
            position: 'relative',
            width: 'full',
            maxWidth: 'var(--leap-sizes-container-page-max-width)',
            overflow: 'hidden',
            bg: 'primary.base.white',
            borderWidth: {s: '1px'},
            borderColor: 'border.subtle',

            // Mobile stays full-width and square; from `s` up the bar renders as
            // a rounded card. Breakpoint-driven, unlike the Xleap header, which
            // switches on the header variant the page declares.
            borderRadius: {
                base: '0px',
                s: 'l'
            }
        },

        bar: {
            width: 'full',
            // Compensate for the card inset so the content remains aligned with
            // the standard page module gutter in both responsive layouts.
            paddingLeft: 'calc(var(--container-inline-padding) - var(--app-header-offset-inline))',
            paddingRight: {
                base: 'spacing-20',
                xs: 'spacing-16',
                s: 'calc(var(--container-inline-padding) - var(--app-header-offset-inline))'
            }
        },

        barInner: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: 'full',
            paddingBlock: 'spacing-16'
        },

        logoLink: {
            display: 'inline-flex',
            alignItems: 'center',
            flexShrink: 0,
            height: 'spacing-32'
        },

        logoIcon: {
            width: 'spacing-68',
            height: 'spacing-14'
        },

        rightSection: {
            display: 'flex',
            alignItems: 'center'
        },

        accountLink: {
            display: 'inline-flex',
            alignItems: 'center'
        },

        secureLabel: {
            textStyle: 'body.xsmall'
        },

        lockIcon: {
            width: '16px',
            height: '16px',
            marginInlineStart: 'spacing-6'
        }
    }
})
